import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/MehrsunPortalRegistration"
    : "SLN/SolarentOperator/MehrsunPortalRegistration";

const MehrsunPortalApi = {
  getCompanyOptions: async (source) =>
    DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetCompanyOptions`
    ),

  startRegistration: async (source, data) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/StartRegistration`,
      data
    ),

  submitRegistration: async (source, data) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/SubmitRegistration`,
      data
    ),

  refreshCaptcha: async (source, data) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/RefreshCaptcha`,
      data
    ),

  /** ثبت/به‌روزرسانی دستی وقتی ثبت‌نام خارج از ارسال اتوماتیک انجام شده */
  registerManual: async (source, data) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/RegisterManual`,
      data
    ),
};

export default MehrsunPortalApi;
